import { mediaQueryUp } from 'components/utils/breakpoint'
import moment from 'moment'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import SearchInputTrigger from '../SearchInputTrigger'
import DateInputValue from './DateInputValue'
import {
  DurationOption,
  durationOptionsDefault,
} from 'components/Search/SearchForm/SearchDateInput/FlexibleDatePicker/DurationPicker'

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: ${rem(300)};
  width: 100%;

  ${mediaQueryUp.sm} {
    width: auto;
  }
`

const DateInputTrigger = styled(SearchInputTrigger)`
  display: block;
  flex-direction: row;
  min-width: ${rem(300)};
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.neutral.five};
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${rem(48)};
`

interface Props {
  onDateToggle: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  flexibleMonths?: string
  flexibleNightsId?: string
  durationOptionsCustom?: DurationOption[];
}

// Input string is in the format of: `03-2022,04-2022,1-2023`
export function transformMonthString(flexibleMonths: string): string {
  if (!flexibleMonths) {
    return
  }
  const monthsWithYears = flexibleMonths.split(',').sort()
  let resultString = ''
  let currentYear = ''
  monthsWithYears.forEach((monthWithYear) => {
    if (!monthWithYear) {
      return
    }
    const [year, month] = monthWithYear.split('-')
    const formattedMonth = moment(month, 'MM').format('MMM')
    if (resultString.length === 0) {
      resultString = `${formattedMonth}`
    }
    if (currentYear === year) {
      resultString = `${resultString}, ${formattedMonth}`
    } else if (currentYear !== year && currentYear.length > 0) {
      resultString = `${resultString} ${currentYear}, ${formattedMonth}`
    }
    currentYear = year
  })
  resultString = `${resultString} ${currentYear}`

  return resultString
}

export function prettyFlexibleDates(flexibleMonths?: string, flexibleNights?: string, durationOptions: DurationOption[] = durationOptionsDefault): string {
  const duration = durationOptions.find((option) => {
    return option.id === flexibleNights
  })
  const monthString = transformMonthString(flexibleMonths)
  let text = duration !== undefined ? `${duration.caption}` : 'I’m flexible'
  if (flexibleMonths?.length > 0) {
    text = `${text} • ${monthString}`
  }
  return text
}

function FlexibleDateTrigger({
  className,
  onDateToggle,
  flexibleMonths,
  flexibleNightsId,
  durationOptionsCustom,
}: Props) {
  const text =
    prettyFlexibleDates(flexibleMonths, flexibleNightsId, durationOptionsCustom)
  return (
    <InputContainer className={className}>
      <DateInputTrigger type="flexible-search-trigger" onClick={onDateToggle}>
        <DateInputValue label="When?" placeholder={text} />
      </DateInputTrigger>
    </InputContainer>
  )
}

export default FlexibleDateTrigger
